import React from 'react';
import { Box, Container } from '@mui/material';
import Footer from '../components/HomeComponent/Footer';
import AccordionUsage from '../components/servicesComponent/Accordin';
import Banner from '../components/ourComponent/Banner';
import FranchiseCards from '../components/ourComponent/FranchiseCard';
import Interested from '../components/aboutComponent/Interested';
import { getResponsiveHeight, getResponsiveSize } from '../utils/responsive';
import globalStyles from '../global';
import ImageCarousel from '../components/ourComponent/ImageCarousel';

const OurPresence = () => {
  return (
    <Box>
      <Banner />
      <FranchiseCards />
      <Interested />
      <Box>
        <Box sx={styles.box2}>
          <Box sx={styles.typography}>UCLEAN COMMUNITY ACROSS THE GLOBE</Box>

          <Container sx={styles.text1}>
            Own a UClean franchise and become a leader in the global laundry
            industry. Our flexible business models and support system ensure a
            seamless start and profitable growth.
          </Container>
          <ImageCarousel />
        </Box>
      </Box>
      <AccordionUsage />
      <Footer />
    </Box>
  );
};
const styles = {
  typography: {
    color: globalStyles.colors.army_green,
    fontSize: getResponsiveSize(45),
   fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
    textAlign: 'center',
    mt: getResponsiveSize(10),
  },
  text1: {
    lineHeight: 1.2,
    height: getResponsiveHeight(79),
   fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
    fontSize: getResponsiveSize(18),
    color: globalStyles.colors.uclean_medium_gray,
    textAlign: 'center',
    mb: getResponsiveHeight(6),
    paddingTop: getResponsiveHeight(6),
  },
  box2: {
    margin: 'auto',
    paddingTop: getResponsiveSize(10),
  },
  typograph: {
    color: globalStyles.colors.army_green,
    fontSize: getResponsiveSize(45),
   fontFamily: ' "Poppins", serif ',
    fontWeight: 700,
    lineHeight: 1.2,
  },
};

export default OurPresence;
